import { NodeProps } from '../../../../types.ts';
import CustomNode from './CustomNode.tsx';
import { useReactFlow, Node } from 'reactflow';
import { useEffect } from 'react';
import {
  LLMHierarchicalPromptConfiguration,
  LLMPromptConfiguration,
  LLMResearchConfiguration,
  WorkflowNode,
} from '../../../../api/model.ts';
import usePrompt from 'api/prompts/usePrompt.ts';

type LLMConfigurationWithInputData =
  | LLMPromptConfiguration
  | LLMResearchConfiguration
  | LLMHierarchicalPromptConfiguration;

const LLMNodeWithInputData = (props: NodeProps) => {
  const reactFlow = useReactFlow();

  const configuration = props.data.configuration as LLMConfigurationWithInputData;
  const { prompt } = usePrompt({ promptId: configuration.prompt_id, revision: configuration.prompt_revision });

  useEffect(() => {
    if (!configuration?.input_data || !prompt) {
      return;
    }
    const inputData = { ...configuration.input_data };
    Object.keys(inputData).forEach((input) => {
      if (!prompt.inputs.includes(input)) {
        delete inputData[input];
      }
    });

    if (JSON.stringify(inputData) === JSON.stringify(configuration.input_data)) {
      return;
    }

    reactFlow.setNodes((nodes) => {
      const node = nodes.find((n) => n.id === props.id) as Node<WorkflowNode> | undefined;
      if (node) {
        node.data.configuration = {
          ...configuration,
          input_data: inputData,
        };
      }
      return nodes;
    });
  }, [prompt, configuration, props.id, reactFlow]);

  return <CustomNode {...props} />;
};

export default LLMNodeWithInputData;
